<!-- 人员选择组件 -->
<template>
  <div class="body">
    <span v-for="(item,index) in userList" :key="index" style="margin-left:15px ;">
      <img v-if="item.img" :src="item.img" class="userAvator" alt />
      <span v-else class="avatortox">{{ item.tox }}</span>
      <!-- <span>{{ item.name }}</span> -->
      <el-popover trigger="hover" placement="right" width="400" @show="showPopover">
        <div>
          <el-descriptions class="margin-top" title="人员信息" :column="2" size="small" border>
            <el-descriptions-item v-if="userInfo.name">
              <template slot="label">
                用户名
              </template>
              {{ userInfo.name }}
            </el-descriptions-item>
            <el-descriptions-item v-if="userInfo.deptName">
              <template slot="label">
                部门名称
              </template>
              {{ userInfo.deptName }}
            </el-descriptions-item>
            <el-descriptions-item v-if="userInfo.deptManager">
              <template slot="label">
                部门领导
              </template>
              {{ userInfo.deptManager }}
            </el-descriptions-item>
            <el-descriptions-item v-if="userInfo.deptLeader">
              <template slot="label">
                部门经理
              </template>
              {{ userInfo.deptLeader }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <span slot="reference">{{ item.name }}</span>
      </el-popover>
      <span v-if="item.isDele&&type!==1" class="deleteBtn" @click="deleUser(item)">
        <i class="el-icon-delete hand delete" title="删除人员"></i>
      </span>
    </span>

    <span v-if="type!==1" class="addbtn" title="添加" @click="showDialog">
      <i class="el-icon-plus"></i>
    </span>

    <el-dialog v-dialogDrag title="人员选择" :visible.sync="isShowDialog" width="30%" :before-close="closeDialog"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <div style="height: 400px;">
        <el-tree ref="userTree" class="userTree" :data="treeData" :props="userTreeProps" highlight-current show-checkbox
          node-key="userId" @check="checkUser">
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取 消</el-button>
        <el-button type="primary" size="small" @click="submitUserList">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { gettouxAvatar } from "@/CommonDP/utils";
import enterprisePersonService from "@/CommonDP/service/enterprisePerson-service";
export default {
  name: "",
  components: {},
  mixins: [],
  props: {
    list: {
      type: Array,
      default: () => []
    },
    type: {
      // 0添加 1查看 2编辑
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      userList: [], // 人员列表
      treeData: [], // 人员树
      userTreeProps: {
        label: "name"
      },
      userInfo: {},
      isShowDialog: false,
      selectList: [] // 人员树选中结果
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    })
  },
  watch: {},
  created() {
    this.getTreeData();
    if (this.list.length) {
      this.setUserList(this.list);
    }
  },
  mounted() {},
  methods: {
    // 获取人员树
    async getTreeData() {
      const params = {
        keyword: "",
        pageSize: 99999,
        pageNum: 1,
        isEnabled: "",
        isExternal: "",
        enterpriseId: this.enterpriseId
      };
      const res = await enterprisePersonService.personListTable(params);
      this.treeData = res.data || [];
    },
    // 返回人员列表
    getUserList() {
      return this.userList;
    },
    setUserList(list) {
      console.log(list);
      list.forEach(ele => {
        const img = gettouxAvatar(ele.userId);
        if (img) {
          ele.img = img;
        } else {
          ele.tox = ele.name.charAt(0);
        }
        ele.isDele = false;
      });
      this.userList = list;
    },
    showDialog() {
      this.isShowDialog = true;
      console.log(this.userList);
      this.$refs.userTree.setCheckedNodes(this.userList, true);
    },
    closeDialog() {
      this.isShowDialog = false;
    },
    // 选中事件
    async checkUser(val, currentChecked) {
      this.selectList = currentChecked.checkedNodes;
    },
    // 确定
    submitUserList() {
      this.selectList.forEach(ele => {
        const img = gettouxAvatar(ele.userId);
        if (img) {
          ele.img = img;
        } else {
          ele.tox = ele.name.charAt(0);
        }
        ele.isDele = true;
      });
      const list = this.selectList.concat(this.userList);
      this.userList = this.unrepeatObjArray(list, "userId"); // 去重
      this.closeDialog();
    },
    // 去重
    unrepeatObjArray(array, keyStr) {
      const map = new Map();
      array.forEach(item => {
        map.set(item[keyStr], item);
      });
      return Array.from(map.values());
    },
    // 删除
    deleUser(item) {
      this.$confirm(`此操作将删除人员 ${item.name} , 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.userList = this.userList.filter(ele => ele.userId !== item.userId);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    showPopover() {
      const inFo = {
        name: "klq",
        deptName: "产品研究院",
        deptManager: "刘晓东",
        deptLeader: "钟玉亮"
      };
      this.userInfo = inFo;
    }
  }
};
</script>

<style scoped lang="scss">
.body {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .userAvator {
    border-radius: 50%;
    width: 16px;
    height: 18px;
    padding-bottom: 2px;
    margin-right: 0px;
    display: inline-block;
    vertical-align: middle;
  }

  .avatortox {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    line-height: 32px;
    margin: 0 auto;
    margin-right: 0px;
    border: 1px solid #4777e7;
    background: #4777e7;
    color: #fff;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
  }
  .hand {
    cursor: pointer;
  }
  .deleteBtn {
    margin-left: 5px;
  }
  .addbtn {
    width: 35px;
    height: 35px;
    margin-left: 5px;
    background: rgba(85, 132, 255, 0.07);
    border: 1px dashed rgba(56, 115, 254, 0.67);
    border-radius: 5px;
    cursor: pointer;
    user-select: none;
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      color: var(--theme-color);
      font-size: 14px;
    }
  }
  .userTree {
    overflow: auto;
    height: 400px;
  }
}
</style>
